// Mock data for EPG Romania Landing Page

export const mockData = {
  header: {
    logoText: "EPG România",
    buttons: [
      { text: "Rezervă un apel", type: "outline" },
      { text: "Confidențialitate", type: "outline" }
    ]
  },
  hero: {
    badge: "Investim în metale prețioase din 2015",
    headline: "Investește în aur și argint stabilind propriile criterii!",
    subheading: "Bun venit la Electrum Prosperity Group România !",
    benefits: [
      "Distribuitor autorizat de metale prețioase, conform reglementărilor",
      "Depozitare securizată și servicii logistice dedicate",
      "Bonusuri în aur pentru recomandările confirmate.",
      "Platformă simplă de administrat, direct de pe telefon"
    ],
    stats: [
      { value: "+$80", label: "În aur pentru", sublabel: "fiecare recomandare" },
      { value: "$500", label: "Recompense", sublabel: "CASH" },
      { value: "$820", label: "Potențial", sublabel: "TOTAL" },
      { value: "Plăți", label: "săptămânale", sublabel: "" }
    ],
    ctas: [
      { text: "Rezervă un apel", type: "primary" },
      { text: "Alătură-te acum !", type: "secondary" }
    ],
    email: "electrumpg@gmail.com",
    videoUrl: process.env.REACT_APP_VIDEO_URL || "https://www.7kmetals.com/stusimonsen/share/xyt25"
  },
  features: [
    {
      title: "4 PRIETENI RECOMANDAȚI = 820 USD",
      description: "Câștigă $320 USD în aur pur (4 x $80) + $500 în recompense în numerar. Mai mult decât costul abonamentului Legacy."
    },
    {
      title: "EȘTI GATA SĂ ÎNCEPI?",
      description: "Dacă ești pregătit să începi, îți punem la dispoziție instruirea completă. Nu este necesară experiență anterioară."
    },
    {
      title: "AFLĂ MAI MULTE !",
      description: ""
    }
  ],
  contactForm: {
    title: "Contact",
    fields: [
      { name: "name", placeholder: "Nume Complet", type: "text" },
      { name: "email", placeholder: "E-mail", type: "email" },
      { name: "phone", placeholder: "Telefon", type: "tel" }
    ],
    submitText: "Trimite și Notifică-mă",
    privacyText: "Sunt de acord să fiu contactat. Vezi",
    privacyLink: "Politica de Confidențialitate"
  },
  footer: {
    copyright: "© 2025 EPG România",
    email: "electrumpg@gmail.com",
    cta: "EȘTI GATA SĂ ÎNCEPI?"
  }
};
